import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  get token() {
    return this.isBrowser ? localStorage.getItem('session_tok') : '';
  }

  clearToken(): void {
    localStorage.removeItem('auth_token'); //Remove the token
  }


  deviceDetail(info?: number): string | number {
    /*---1=device_token, 2=deviceId, 3=platform---*/
    switch (info) {
      case 1:
        return '123';
      case 2:
        let deviceId = this.randomDeviceId();
        return deviceId;
      case 3:
        return '3';
      case 4:
        return this.getTimeZone();
      default:
        return ''; // Provide a default return value
    }
  }

  randomDeviceId() {
    return window.navigator.userAgent.replace(/\D+/g, '');
  }

  getTimeZone() {
    let date = new Date();
    let offset = date.getTimezoneOffset() * -1;
    return offset * 60 * 1000;
  }
}
